/**
 * @description 获取设备像素比 https://developer.mozilla.org/zh-CN/docs/Web/API/Window/devicePixelRatio
 * @returns {number} 设备像素比
 */
const getDevicePixelRatio = (): number =>
  typeof window !== undefined ? window.devicePixelRatio : 1;

export default getDevicePixelRatio;
